import React, { useState, useEffect } from 'react';
import SafeIcon from '../../../common/SafeIcon';
import supabase from '../../../supabase/supabase';
import { cn } from '../../../components/ui/Button';

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('bookings_1740423033529')
        .select(`
          *,
          customer:customer_id(full_name),
          barber:barber_id(full_name),
          service:service_id(name)
        `)
        .order('created_at', { ascending: false });
      
      if (!error) setBookings(data || []);
      setLoading(false);
    };

    fetchBookings();
  }, []);

  return (
    <div className="animate-in fade-in duration-500">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-black text-brand-dark tracking-tight">Global Log</h1>
          <p className="text-gray-500 font-medium italic">Complete platform monitoring of all appointments.</p>
        </div>
      </div>

      <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          {loading ? (
            <div className="p-12 text-center text-gray-400 font-bold uppercase text-[10px] tracking-widest">
              Syncing logic...
            </div>
          ) : bookings.length === 0 ? (
            <div className="p-20 text-center text-gray-400 italic">No bookings recorded on the platform yet.</div>
          ) : (
            <table className="w-full text-left">
              <thead>
                <tr className="text-gray-400 text-[10px] uppercase tracking-widest font-black border-b border-gray-50 bg-gray-50/50">
                  <th className="px-8 py-5">Customer</th>
                  <th className="px-8 py-5">Barber</th>
                  <th className="px-8 py-5">Service</th>
                  <th className="px-8 py-5">Schedule</th>
                  <th className="px-8 py-5">Total</th>
                  <th className="px-8 py-5">Status</th>
                  <th className="px-8 py-5">Payment</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {bookings.map((b) => (
                  <tr key={b.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-8 py-5 font-bold text-brand-dark">
                      {b.customer?.full_name || <span className="text-gray-400 italic font-medium">Deleted User</span>}
                    </td>
                    <td className="px-8 py-5 text-sm font-medium text-gray-600">
                      {b.barber?.full_name || <span className="text-gray-400 italic">Deleted Barber</span>}
                    </td>
                    <td className="px-8 py-5">
                      <span className="text-xs font-black text-brand-primary bg-brand-primary/5 px-2 py-1 rounded-lg">
                        {b.service?.name || 'Removed Service'}
                      </span>
                    </td>
                    <td className="px-8 py-5">
                      <p className="text-sm font-bold text-gray-600">{b.booking_date}</p>
                      <p className="text-[10px] font-black text-gray-400 uppercase">{b.booking_time}</p>
                    </td>
                    <td className="px-8 py-5 font-black text-brand-dark">Rs. {Number(b.total_price || 0).toLocaleString()}</td>
                    <td className="px-8 py-5">
                      <span className={cn(
                        "px-3 py-1 rounded-full text-[10px] font-black uppercase border",
                        b.status === 'completed' ? "bg-green-50 text-green-600 border-green-100" :
                        b.status === 'cancelled' ? "bg-red-50 text-red-600 border-red-100" :
                        "bg-blue-50 text-blue-600 border-blue-100"
                      )}>
                        {b.status}
                      </span>
                    </td>
                    <td className="px-8 py-5">
                      <span className={cn(
                        "px-3 py-1 rounded-full text-[10px] font-black uppercase border",
                        b.payment_status === 'paid' ? "bg-green-50 text-green-600 border-green-100" :
                        "bg-orange-50 text-orange-600 border-orange-100"
                      )}>
                        {b.payment_status === 'paid' ? 'Paid' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}